import { render, staticRenderFns } from "./mnewsmange.vue?vue&type=template&id=2f6a7e9c&scoped=true&"
import script from "./mnewsmange.vue?vue&type=script&lang=js&"
export * from "./mnewsmange.vue?vue&type=script&lang=js&"
import style0 from "./mnewsmange.vue?vue&type=style&index=0&id=2f6a7e9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6a7e9c",
  null
  
)

export default component.exports